import React, { useState, useEffect, useCallback, useMemo } from "react";
import Badge from "@mui/material/Badge";
import NotificationsIcon from "@mui/icons-material/NotificationsNone";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import NotificationBox from "../../../Notification/NotificationBox";
import * as userActions from "redux/actions/userActions";
import { useLocation } from "react-router-dom";

const Notification = () => {
  const location = useLocation();
  const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.currentUser.details.id);
  const count = useSelector(
    (state) => state.currentUser.unReadNotification?.unReadNotificationCount ?? 0
  );
  const selectedClient = useSelector((state) => state.clients.selectedClient);
  const selectedClientId = useSelector(
    (state) => state.clients.selectedClientId
  );

  useEffect(() => {
    if (userId && selectedClient?.clientId && selectedClientId) {
      dispatch(
        userActions.getUnreadNotificationCount(userId, selectedClientId)
      );
    }
  }, [dispatch, userId, location, selectedClientId]);

  const onNotificationClick = useCallback(() => {
    if (userId && selectedClientId) {
      dispatch(
        userActions.getUnreadNotificationCount(userId, selectedClientId)
      );     
      dispatch(userActions.resetNotifications());
      setIsNotificationModalOpen(true);     
    }
  }, [userId, selectedClientId]);

  const onCloseNotificationModal = useCallback(() => {
    setIsNotificationModalOpen(false);
  }, []);

  const notificationIcon = useMemo(
    () => <NotificationsIcon />,
    [onNotificationClick]
  );

  return (
    <>
      {isNotificationModalOpen && (
        <NotificationBox
          open={isNotificationModalOpen}
          onClose={onCloseNotificationModal}
        />
      )}
      <div className="notify">
        <Badge
          badgeContent={count || null}
          variant="standard"
          overlap="circular"
          onClick={onNotificationClick}
        >
          {notificationIcon}
        </Badge>
      </div>
    </>
  );
};

export default React.memo(Notification);
